import { Card } from "../../../components/ui/card";
import { useEffect, useState } from "react";
import { Button } from "../../../components/ui/button";
import { Navigate, useNavigate } from "react-router-dom";
import { showErrorToast, showSuccessToast } from "../../../utils/toast-utils";
import { EyeOff, Eye } from "lucide-react";
import { Input } from "../../../components/ui/input";
import { doPatientLogin, patientForgotPassword, patientVerifyOtp, patientResetPassword } from "../../../services/patient/patientAuthService";
import Loader from "../../../components/loader/loader";
import { getRequest } from "../../../config/axiosConfig";
import { ResetPasswordModal } from "../../../components/reset-password/reset-password";

const PatientLogin = () => {
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [step, setStep] = useState("login");
  const [isLoading, setIsLoading] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [checkAuthLoading, setCheckAuthLoading] = useState(true);
  const [verifyPhone, setVerifyPhone] = useState();
  const [showResetModal, setShowResetModal] = useState(false);
  const [forgotData, setForgotData] = useState();

  const [formData, setFormData] = useState({
    phone: "",
    password: "",
    forgotPhone: "",
    otp: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {

      if (!/^\d*$/.test(value) || value.length > 10) return;

      setFormData((prev) => ({ ...prev, phone: value }));

      setErrors((prev) => ({
        ...prev,
        phone:
          value.length !== 10 ? "Phone number must be exactly 10 digits" : "",
      }));

      return;
    }

    if (name === "forgotPhone") {
      if (!/^\d*$/.test(value) || value.length > 10) return;

      setFormData((prev) => ({ ...prev, forgotPhone: value }));
      setErrors((prev) => ({
        ...prev,
        forgotPhone:
          value.length !== 10 ? "Phone number must be exactly 10 digits" : "",
      }));
      return;
    }

    if (name === "password") {
      const passwordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

      setFormData((prev) => ({ ...prev, password: value }));

      setErrors((prev) => ({
        ...prev,
        password: passwordRegex.test(value)
          ? ""
          : "Min 8 chars, include uppercase, lowercase, number & special character",
      }));
      return;
    }


    if (name === "otp") {
      if (!/^\d*$/.test(value) || value.length > 6) return;

      setFormData((prev) => ({ ...prev, otp: value }));
      setErrors((prev) => ({
        ...prev,
        otp: value.length !== 6 ? "OTP must be exactly 6 digits" : "",
      }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  //----------------------------- Handle Login -------------------------------//

    const handleLogin = async () => {
  if (!formData.phone || !formData.password) {
    return showErrorToast("please enter details");
  }

  setIsLoading(true);

  try {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const updatedForm = {
          ...formData,
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };
       //    console.log("Sending form:", updatedForm);
        const res = await doPatientLogin(updatedForm);

        if (res?.status === 200 || res?.data?.status === 200) {
          showSuccessToast(
            res?.message ||
              res?.data?.message ||
              "Patient Login Successful",
          );
          navigate("/patient-dashboard");
        } else {
          showErrorToast(
            res?.message ||
              res?.data?.message ||
              res?.data?.data?.message,
          );
        }

        setIsLoading(false);
      },
      async (error) => {
        console.log("Location permission denied");

        // If user denies location, still allow login
        const res = await doPatientLogin(formData);

        if (res?.status === 200 || res?.data?.status === 200) {
          showSuccessToast(
            res?.message ||
              res?.data?.message ||
              "Patient Login Successful",
          );
          navigate("/patient-dashboard");
        } else {
          showErrorToast(
            res?.message ||
              res?.data?.message ||
              res?.data?.data?.message,
          );
        }

        setIsLoading(false);
      }
    );
  } catch (error) {
    console.log(error);
    setIsLoading(false);
  }
};
  //---------------- Handle forgot password -------------------------------//

  const handleForgotPassword = async () => {

    if (!formData.forgotPhone) {
      return showErrorToast("Please enter phone no");
    }

    if (formData.forgotPhone.length !== 10) {
      return showErrorToast("Phone number must be 10 digits");
    }

    setIsLoading(true);

    try {

      const payload = {
        forgotPhone: formData.forgotPhone,
      };
      const res = await patientForgotPassword(payload);

      const status = res?.data?.status;

      if (status === 200) {

        showSuccessToast(
          res?.data?.message || "Otp Send Successfully",
        );

        setStep("otp");
        setVerifyPhone(formData.forgotPhone);

      } else {

        showErrorToast(res?.data?.data?.message || "Something went wrong")

      }

    } catch (error) {

      showErrorToast(error?.response?.data?.message || "Something went wrong");
      setIsLoading(false);

    } finally {
      setIsLoading(false);
    }
  };

  const handleVerifyOTP = async () => {

    if (!formData.otp) {
      return showErrorToast("Please enter otp");
    }

    if (formData.otp.length !== 6) {
      return showErrorToast("Otp must be 6 digits")
    }

    if (!verifyPhone) {
      return showErrorToast("Please enter phone no");
    }

    if (verifyPhone.length !== 10) {
      return showErrorToast("Phone number must be 10 digits");
    }

    setIsLoading(true);

    try {
      const payload = {
        phone: verifyPhone,
        otp: formData.otp,
      };

      const res = await patientVerifyOtp(payload);

      const status = res?.data?.status;

      if (status === 200) {

        showSuccessToast(res?.data?.message || "Otp Verify");

        setForgotData(res);
        setShowResetModal(true);

      } else {

        showErrorToast(res?.data?.data?.message || "Something went wrong");

      }

    } catch (error) {

      showErrorToast(error?.response?.data?.message || "Something went wrong");
      setIsLoading(false);

    }
    finally {

      setIsLoading(false);

    }

  };

  const handleResetPassword = async (newPassword, confirmPassword) => {
    setIsLoading(true);

    try {

      const payload = {
        tempToken: forgotData?.data?.data?.isOtpValid?.tempToken,
        newPassword,
        confirmPassword,
      };

      const res = await patientResetPassword(payload);

      const status = res?.data?.status;

      if (status === 200) {
        showSuccessToast(res?.data?.message || "Password Reset successfully");

        setShowResetModal(false);
        setStep("login");


        setFormData({
          phone: "",
          password: "",
          forgotPhone: "",
          otp: "",
        });

      } else {
        showErrorToast(
          showErrorToast(res?.data?.data?.message || "Something went wrong")
        );
      }

    } catch (error) {

      showErrorToast(error?.response?.data?.message || "Something went wrong");

    } finally {

      setIsLoading(false);

    }
  };

  const home = () => {
    navigate("/");
  };

  useEffect(() => {
    const checkPatientAuth = async () => {
      try {
        const res = await getRequest({
          url: process.env.REACT_APP_BASE_URL + "auth/patient/me-patient",
        });

        if (res?.success) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.log(error);
        setIsAuthenticated(false);
      } finally {
        setCheckAuthLoading(false);
      }
    };

    checkPatientAuth();
  }, []);

  if (checkAuthLoading) return <Loader />;

  if (isAuthenticated) {
    return <Navigate to="/patient-dashboard" replace />;
  }

  return (
    <>
      <div className="bg-gradient-to-r from-[#0a3d62] to-[#1e90ff]">
        {isLoading && <Loader />}
        <div>
          <Button
            onClick={home}
            variant="patient.tracery"
            className="ml-10 mt-2"
          >
            Back To Home
          </Button>
        </div>
        <div className="min-h-[calc(100vh-48px)]  bg-gradient-to-r from-[#0a3d62] to-[#1e90ff] flex items-center justify-center">
          <Card className="w-full md:w-[100vh] min-h-[33.33vh] border-[#105daa] ">
            <div className="md:flex md:flex-row w-full rounded-xl">
              <div
                className="w-full md:w-2/5 min-h-[30vh] md:min-h-[33.33vh]
                                    bg-gradient-to-r from-[#0a3d62] to-[#1e90ff] md:rounded-l-2xl flex items-center"
              >
                <div className="text-white w-full items-center text-center md:px-14 md:items-start md:text-left">
                  <h2 className="text-2xl sm:text-3xl font-bold mb-3">
                    Patient Login
                  </h2>

                  <p className="text-sm sm:text-md mb-5">
                    Secure access to your health services
                  </p>

                  <ul className="text-sm sm:text-md space-y-2">
                    <li>✔ Use registered Mobile Number</li>
                    <li>✔ Keep your password confidential</li>
                    <li>✔ OTP will be required for verification</li>
                    <li>✔ Never share OTP with anyone</li>
                  </ul>
                </div>
              </div>

              <div className="rounded-b-2xl sm:rounded-b-none  md:rounded-r-2xl md:w-3/5 min-h-[33.33vh] p-12 bg-white text-black">
                {step === "login" && (
                  <div>
                    <h3 className="text-2xl font-bold mb-4">Sign In</h3>
                    <div>
                      <Input
                        type="number"
                        name="phone"
                        placeholder="Phone Number"
                        value={formData.phone}
                        onChange={handleChange}
                        className="mb-2"
                      />
                      {errors.phone && (
                        <p className="text-red-500 text-sm mb-2">
                          {errors.phone}
                        </p>
                      )}
                    </div>
                    <div className="relative mb-4">
                      <Input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Password"
                        value={formData.password}
                        onChange={handleChange}
                      />
                      {errors.password && (
                        <p className="text-red-500 text-sm mb-2">
                          {errors.password}
                        </p>
                      )}

                      <Button
                        variant="patient.default"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-[1px] -translate-y-1/2 text-sm text-blue-600 top-[22px] px-2"
                      >
                        {showPassword ? (
                          <EyeOff size={18} />
                        ) : (
                          <Eye size={18} />
                        )}
                      </Button>
                    </div>

                    <Button
                      onClick={handleLogin}
                      disabled={formData.phone?.length !== 10 || !formData.password || errors.password || isLoading}
                      variant="patient.secondary"
                      className="w-full text-lg font-semibold"
                    >
                      Login
                    </Button>

                    <div className="mt-3 text-sm text-right ">
                      <Button
                        onClick={() => setStep("forgot")}
                        variant="patient.link"
                      >
                        Forgot Password?
                      </Button>
                    </div>
                  </div>
                )}

                {/* STEP 2: FORGOT PASSWORD */}
                {step === "forgot" && (
                  <div>
                    <h3 className="text-2xl font-bold mb-4">Reset Password</h3>
                    <p className="text-sm text-gray-600 mb-4">
                      OTP will be sent to registered Phone/Email
                    </p>

                    <div>
                      <Input
                        type="number"
                        name="forgotPhone"
                        placeholder="Phone Number"
                        value={formData.forgotPhone}
                        onChange={handleChange}
                        className="mb-2"
                      />
                      {errors.forgotPhone && (
                        <p className="text-red-500 text-sm mb-2">
                          {errors.forgotPhone}
                        </p>
                      )}
                    </div>

                    <Button
                      disabled={formData?.forgotPhone?.length !== 10}
                      onClick={handleForgotPassword}
                      variant="admin.secondary"
                      className="w-full text-xl font-bold"
                    >
                      Send OTP
                    </Button>

                    <div className="mt-3 text-sm text-right">
                      <Button
                        onClick={() => setStep("login")}
                        variant="admin.link"
                      >
                        Back to Login
                      </Button>
                    </div>
                  </div>
                )}

                {/* STEP 3: OTP */}
                {step === "otp" && (
                  <div>
                    <h3 className="text-2xl font-bold mb-4">
                      Two-Factor Authentication
                    </h3>
                    <p className="text-sm text-gray-600 mb-4">
                      Enter OTP sent to your registered Phone/Email
                    </p>
                    <div>
                      <Input
                        type="number"
                        name="otp"
                        placeholder="Enter 6-digit OTP"
                        value={formData.otp}
                        onChange={handleChange}
                        className="w-full border p-2 mb-2 rounded"
                      />

                      {errors.otp && (
                        <p className="text-red-500 text-sm">{errors.otp}</p>
                      )}
                    </div>

                    <Button
                      onClick={handleVerifyOTP}
                      disabled={formData.otp.length !== 6}
                      className={`w-full p-2 mt-2 rounded ${formData?.otp?.length === 6
                        ? "bg-green-600 text-white cursor-pointer"
                        : "bg-gray-400 cursor-not-allowed"
                        }`}
                    >
                      Verify OTP
                    </Button>
                    <p className="mt-3 text-sm text-center">
                      Didn’t receive OTP?{" "}
                      <Button variant="admin.link">Resend</Button>
                    </p>
                  </div>
                )}

              </div>
            </div>
          </Card>
        </div>

        {showResetModal && (
          <ResetPasswordModal
            onClose={() => setShowResetModal(false)}
            onSubmit={handleResetPassword}
            isLoading={isLoading}
          />
        )}

      </div>
    </>
  );
};

export default PatientLogin;
